import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthStore, AUTH_STORAGE_KEY } from '../../store';

export default function PortalSession({ children }) {
  const { pathname } = useLocation();
  const portal = ['superadmin', 'admin', 'staff'].find(p => pathname.startsWith(`/${p}`)) || null;
  const active = useAuthStore(s => s.activePortal);
  const hydrated = useAuthStore(s => s.hydrated);
  useLayoutEffect(() => {
    if (hydrated && active !== portal) useAuthStore.getState().activatePortal(portal);
  }, [portal, active, hydrated]);
  useLayoutEffect(() => {
    const sync = event => {
      if (event.key !== AUTH_STORAGE_KEY) return;
      try {
        const sessions = JSON.parse(event.newValue || '{}').state?.sessions || {};
        useAuthStore.setState({ sessions });
        useAuthStore.getState().activatePortal(portal);
      } catch { /* Ignore malformed external storage. */ }
    };
    window.addEventListener('storage', sync);
    return () => window.removeEventListener('storage', sync);
  }, [portal]);
  return hydrated && active === portal ? children : null;
}
